import { render, staticRenderFns } from "./PostGroup.vue?vue&type=template&id=0bc2001c&scoped=true&"
import script from "./PostGroup.vue?vue&type=script&lang=js&"
export * from "./PostGroup.vue?vue&type=script&lang=js&"
import style0 from "./PostGroup.vue?vue&type=style&index=0&id=0bc2001c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc2001c",
  null
  
)

export default component.exports